import { useMemo, type ComponentType } from 'react';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import type { PromptOverviewTopBrand } from '../../types';
import { promptOverviewTopBrandsColumnConfig } from '../../config/promptOverviewTopBrandsColumnConfig';

type AgGridWrapperProps = {
  table_name?: string;
  height?: string;
  columns: unknown[];
  data: unknown[];
  total?: number;
  settings?: Record<string, unknown>;
  otherOptions?: Record<string, unknown>;
};
const TypedAgGridWrapper = AgGridWrapper as ComponentType<AgGridWrapperProps>;

export function PromptOverviewTopBrandsTable({ brands }: { brands: PromptOverviewTopBrand[] }) {
  const columns = useMemo(() => promptOverviewTopBrandsColumnConfig(), []);

  const otherOptions = useMemo(
    () => ({
      getRowStyle: (params: { data?: PromptOverviewTopBrand }) =>
        params.data?.relationship === 'you' ? { background: 'rgba(25, 135, 84, 0.08)' } : undefined,
    }),
    [],
  );

  if (!brands.length) {
    return (
      <p className="py-5 text-center fs--1 text-500 mb-0">
        هنوز برندی در پاسخ‌های این پرامپت شناسایی نشده.
      </p>
    );
  }

  return (
    <TypedAgGridWrapper
      table_name="tracker_ai_prompt_overview_top_brands"
      height="auto"
      columns={columns}
      data={brands}
      total={brands.length}
      settings={{ pagination: false, fullscreen: false, sideBar: false, export: { enabled: false } }}
      otherOptions={otherOptions}
    />
  );
}
